// import React, { useState } from 'react';
// import {
//   Box,
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemText,
//   ListItemIcon,
//   Typography,
//   Toolbar,
//   CssBaseline,
//   Divider,
//   Avatar,
//   Chip,
// } from '@mui/material';

// import PersonAddIcon from '@mui/icons-material/PersonAdd';
// import GroupIcon from '@mui/icons-material/Group';
// import PeopleIcon from '@mui/icons-material/People';
// import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
// import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
// import StorefrontIcon from '@mui/icons-material/Storefront';
// import DashboardIcon from '@mui/icons-material/Dashboard';

// import DriverRegistration from './admin/driver/DriverRegistration';
// import UserRecords from './admin/UserRecords';
// import RideRecords from './admin/RideRecords';
// import AllDrivers from './admin/driver/AllDrivers';
// import ManageRoles from './admin/ManageRoles';
// import VendorRecords from './vendor/VendorRecords';

// import SharedHeader from '../components/SharedHeader';
// import { tokenStorage } from '../utils/tokenStorage';

// const drawerWidth = 260;

// const AdminDashboard = () => {
//   const [selectedPage, setSelectedPage] = useState('Ride Records');
//   const adminUser = tokenStorage.getUser();

//   const renderContent = () => {
//     switch (selectedPage) {
//       case 'Ride Records':
//         return <RideRecords />;
//       case 'Vendor Management':
//         return <VendorRecords />;
//       case 'Driver Registration':
//         return <DriverRegistration />;
//       case 'All Drivers':
//         return <AllDrivers />;
//       case 'User Records':
//         return <UserRecords />;
//       case 'Manage Roles':
//         return <ManageRoles />;
//       default:
//         return <Typography variant="h6">Select an option</Typography>;
//     }
//   };

//   // Group menu items into logical sections
//   const menuSections = [
//     {
//       title: 'Operations',
//       items: [
//         { label: 'Ride Records', icon: <LocalTaxiIcon /> },
//         { label: 'Vendor Management', icon: <StorefrontIcon /> },
//       ],
//     },
//     {
//       title: 'Drivers',
//       items: [
//         { label: 'Driver Registration', icon: <PersonAddIcon /> },
//         { label: 'All Drivers', icon: <GroupIcon /> },
//       ],
//     },
//     {
//       title: 'Administration',
//       items: [
//         { label: 'User Records', icon: <PeopleIcon /> },
//         { label: 'Manage Roles', icon: <AdminPanelSettingsIcon /> },
//       ],
//     },
//   ];

//   return (
//     <Box sx={{ display: 'flex' }}>
//       <CssBaseline />

//       {/* Shared Header */}
//       <Box
//         sx={{
//           position: 'fixed',
//           width: '100%',
//           zIndex: (theme) => theme.zIndex.drawer + 1,
//         }}
//       >
//         <SharedHeader />
//       </Box>

//       {/* Sidebar */}
//       <Drawer
//         variant="permanent"
//         sx={{
//           width: drawerWidth,
//           flexShrink: 0,
//           [`& .MuiDrawer-paper`]: {
//             width: drawerWidth,
//             boxSizing: 'border-box',
//             borderRight: '1px solid',
//             borderColor: 'divider',
//             bgcolor: '#fafbfc',
//           },
//         }}
//       >
//         <Toolbar />

//         {/* Admin profile section */}
//         <Box
//           sx={{
//             p: 2.5,
//             display: 'flex',
//             alignItems: 'center',
//             gap: 1.5,
//             borderBottom: '1px solid',
//             borderColor: 'divider',
//             bgcolor: 'white',
//           }}
//         >
//           <Avatar
//             sx={{
//               bgcolor: 'primary.main',
//               width: 44,
//               height: 44,
//               fontSize: '1rem',
//               fontWeight: 700,
//             }}
//           >
//             {adminUser?.userName?.charAt(0)?.toUpperCase() || 'A'}
//           </Avatar>
//           <Box flex={1} minWidth={0}>
//             <Typography
//               variant="body2"
//               fontWeight={600}
//               noWrap
//               sx={{ lineHeight: 1.2 }}
//             >
//               {adminUser?.userName || 'Admin'}
//             </Typography>
//             <Chip
//               label="Administrator"
//               size="small"
//               icon={<AdminPanelSettingsIcon sx={{ fontSize: 14 }} />}
//               sx={{
//                 mt: 0.5,
//                 height: 20,
//                 fontSize: '0.7rem',
//                 bgcolor: 'primary.50',
//                 color: 'primary.dark',
//                 '& .MuiChip-icon': { color: 'primary.dark' },
//               }}
//             />
//           </Box>
//         </Box>

//         {/* Navigation menu */}
//         <Box sx={{ overflow: 'auto', py: 1 }}>
//           {menuSections.map((section, sectionIdx) => (
//             <Box key={section.title}>
//               {/* Section title */}
//               <Typography
//                 variant="caption"
//                 sx={{
//                   px: 2.5,
//                   py: 1,
//                   display: 'block',
//                   color: 'text.secondary',
//                   fontWeight: 600,
//                   letterSpacing: 0.5,
//                   textTransform: 'uppercase',
//                   fontSize: '0.7rem',
//                   mt: sectionIdx === 0 ? 0 : 1,
//                 }}
//               >
//                 {section.title}
//               </Typography>

//               {/* Section items */}
//               <List sx={{ py: 0 }}>
//                 {section.items.map((item) => {
//                   const isSelected = selectedPage === item.label;
//                   return (
//                     <ListItem key={item.label} disablePadding sx={{ px: 1 }}>
//                       <ListItemButton
//                         onClick={() => setSelectedPage(item.label)}
//                         selected={isSelected}
//                         sx={{
//                           borderRadius: 1.5,
//                           mb: 0.25,
//                           py: 1,
//                           transition: 'all 0.15s',
//                           '&.Mui-selected': {
//                             bgcolor: 'primary.main',
//                             color: 'white',
//                             '&:hover': {
//                               bgcolor: 'primary.dark',
//                             },
//                             '& .MuiListItemIcon-root': {
//                               color: 'white',
//                             },
//                           },
//                           '&:hover': {
//                             bgcolor: isSelected ? 'primary.dark' : 'action.hover',
//                           },
//                         }}
//                       >
//                         <ListItemIcon
//                           sx={{
//                             minWidth: 36,
//                             color: isSelected ? 'white' : 'text.secondary',
//                           }}
//                         >
//                           {item.icon}
//                         </ListItemIcon>
//                         <ListItemText
//                           primary={item.label}
//                           primaryTypographyProps={{
//                             fontSize: '0.875rem',
//                             fontWeight: isSelected ? 600 : 500,
//                           }}
//                         />
//                       </ListItemButton>
//                     </ListItem>
//                   );
//                 })}
//               </List>

//               {/* Divider between sections (not after last) */}
//               {sectionIdx < menuSections.length - 1 && (
//                 <Divider sx={{ mx: 2, my: 1 }} />
//               )}
//             </Box>
//           ))}
//         </Box>

//         {/* Footer */}
//         <Box
//           sx={{
//             mt: 'auto',
//             p: 2,
//             borderTop: '1px solid',
//             borderColor: 'divider',
//             bgcolor: 'white',
//           }}
//         >
//           <Typography variant="caption" color="text.secondary" display="block">
//             Gatiii Admin Panel
//           </Typography>
//           <Typography variant="caption" color="text.disabled" display="block">
//             v1.0.0
//           </Typography>
//         </Box>
//       </Drawer>

//       {/* Main Content */}
//       <Box
//         component="main"
//         sx={{
//           flexGrow: 1,
//           bgcolor: '#f5f7fa',
//           p: 3,
//           minHeight: '100vh',
//           mt: '72px',
//         }}
//       >
//         {/* Page header */}
//         <Box mb={3}>
//           <Box display="flex" alignItems="center" gap={1} mb={0.5}>
//             <DashboardIcon color="primary" fontSize="small" />
//             <Typography variant="caption" color="text.secondary">
//               Admin Dashboard
//             </Typography>
//           </Box>
//           <Typography variant="h5" fontWeight="bold">
//             {selectedPage}
//           </Typography>
//         </Box>

//         {renderContent()}
//       </Box>
//     </Box>
//   );
// };

// export default AdminDashboard;
import React, { useState } from 'react';
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  ListItemIcon,
  Typography,
  Toolbar,
  CssBaseline,
  Divider,
  Avatar,
  Chip,
} from '@mui/material';

import PersonAddIcon from '@mui/icons-material/PersonAdd';
import GroupIcon from '@mui/icons-material/Group';
import PeopleIcon from '@mui/icons-material/People';
import LocalTaxiIcon from '@mui/icons-material/LocalTaxi';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import StorefrontIcon from '@mui/icons-material/Storefront';
import DashboardIcon from '@mui/icons-material/Dashboard';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';   // ← ADD

import DriverRegistration from './admin/driver/DriverRegistration';
import UserRecords from './admin/UserRecords';
import RideRecords from './admin/RideRecords';
import AllDrivers from './admin/driver/AllDrivers';
import ManageRoles from './admin/ManageRoles';
import VendorRecords from './vendor/VendorRecords';
import KpiDashboard from './admin/KpiDashboard';               // ← ADD

import SharedHeader from '../components/SharedHeader';
import { tokenStorage } from '../utils/tokenStorage';

const drawerWidth = 260;

const AdminDashboard = () => {
  const [selectedPage, setSelectedPage] = useState('KPI Dashboard');  // ← default to KPI
  const adminUser = tokenStorage.getUser();

  const renderContent = () => {
    switch (selectedPage) {
      case 'KPI Dashboard':                                     // ← ADD
        return <KpiDashboard />;
      case 'Ride Records':
        return <RideRecords />;
      case 'Vendor Management':
        return <VendorRecords />;
      case 'Driver Registration':
        return <DriverRegistration />;
      case 'All Drivers':
        return <AllDrivers />;
      case 'User Records':
        return <UserRecords />;
      case 'Manage Roles':
        return <ManageRoles />;
      default:
        return <Typography variant="h6">Select an option</Typography>;
    }
  };

  const menuSections = [
    {
      title: 'Analytics',                                       // ← ADD section
      items: [
        { label: 'KPI Dashboard', icon: <TrendingUpIcon /> },
      ],
    },
    {
      title: 'Operations',
      items: [
        { label: 'Ride Records', icon: <LocalTaxiIcon /> },
        { label: 'Vendor Management', icon: <StorefrontIcon /> },
      ],
    },
    {
      title: 'Drivers',
      items: [
        { label: 'Driver Registration', icon: <PersonAddIcon /> },
        { label: 'All Drivers', icon: <GroupIcon /> },
      ],
    },
    {
      title: 'Administration',
      items: [
        { label: 'User Records', icon: <PeopleIcon /> },
        { label: 'Manage Roles', icon: <AdminPanelSettingsIcon /> },
      ],
    },
  ];

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {/* Shared Header */}
      <Box
        sx={{
          position: 'fixed',
          width: '100%',
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <SharedHeader />
      </Box>

      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: 'border-box',
            borderRight: '1px solid',
            borderColor: 'divider',
            bgcolor: '#fafbfc',
          },
        }}
      >
        <Toolbar />

        {/* Admin profile section */}
        <Box
          sx={{
            p: 2.5,
            display: 'flex',
            alignItems: 'center',
            gap: 1.5,
            borderBottom: '1px solid',
            borderColor: 'divider',
            bgcolor: 'white',
          }}
        >
          <Avatar
            sx={{
              bgcolor: 'primary.main',
              width: 44,
              height: 44,
              fontSize: '1rem',
              fontWeight: 700,
            }}
          >
            {adminUser?.userName?.charAt(0)?.toUpperCase() || 'A'}
          </Avatar>
          <Box flex={1} minWidth={0}>
            <Typography
              variant="body2"
              fontWeight={600}
              noWrap
              sx={{ lineHeight: 1.2 }}
            >
              {adminUser?.userName || 'Admin'}
            </Typography>
            <Chip
              label="Administrator"
              size="small"
              icon={<AdminPanelSettingsIcon sx={{ fontSize: 14 }} />}
              sx={{
                mt: 0.5,
                height: 20,
                fontSize: '0.7rem',
                bgcolor: 'primary.50',
                color: 'primary.dark',
                '& .MuiChip-icon': { color: 'primary.dark' },
              }}
            />
          </Box>
        </Box>

        {/* Navigation menu */}
        <Box sx={{ overflow: 'auto', py: 1 }}>
          {menuSections.map((section, sectionIdx) => (
            <Box key={section.title}>
              <Typography
                variant="caption"
                sx={{
                  px: 2.5,
                  py: 1,
                  display: 'block',
                  color: 'text.secondary',
                  fontWeight: 600,
                  letterSpacing: 0.5,
                  textTransform: 'uppercase',
                  fontSize: '0.7rem',
                  mt: sectionIdx === 0 ? 0 : 1,
                }}
              >
                {section.title}
              </Typography>

              <List sx={{ py: 0 }}>
                {section.items.map((item) => {
                  const isSelected = selectedPage === item.label;
                  return (
                    <ListItem key={item.label} disablePadding sx={{ px: 1 }}>
                      <ListItemButton
                        onClick={() => setSelectedPage(item.label)}
                        selected={isSelected}
                        sx={{
                          borderRadius: 1.5,
                          mb: 0.25,
                          py: 1,
                          transition: 'all 0.15s',
                          '&.Mui-selected': {
                            bgcolor: 'primary.main',
                            color: 'white',
                            '&:hover': { bgcolor: 'primary.dark' },
                            '& .MuiListItemIcon-root': { color: 'white' },
                          },
                          '&:hover': {
                            bgcolor: isSelected ? 'primary.dark' : 'action.hover',
                          },
                        }}
                      >
                        <ListItemIcon
                          sx={{
                            minWidth: 36,
                            color: isSelected ? 'white' : 'text.secondary',
                          }}
                        >
                          {item.icon}
                        </ListItemIcon>
                        <ListItemText
                          primary={item.label}
                          primaryTypographyProps={{
                            fontSize: '0.875rem',
                            fontWeight: isSelected ? 600 : 500,
                          }}
                        />
                      </ListItemButton>
                    </ListItem>
                  );
                })}
              </List>

              {sectionIdx < menuSections.length - 1 && (
                <Divider sx={{ mx: 2, my: 1 }} />
              )}
            </Box>
          ))}
        </Box>

        {/* Footer */}
        <Box
          sx={{
            mt: 'auto',
            p: 2,
            borderTop: '1px solid',
            borderColor: 'divider',
            bgcolor: 'white',
          }}
        >
          <Typography variant="caption" color="text.secondary" display="block">
            Gatiii Admin Panel
          </Typography>
          <Typography variant="caption" color="text.disabled" display="block">
            v1.0.0
          </Typography>
        </Box>
      </Drawer>

      {/* Main Content */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: '#f5f7fa',
          p: 3,
          minHeight: '100vh',
          mt: '72px',
        }}
      >
        <Box mb={3}>
          <Box display="flex" alignItems="center" gap={1} mb={0.5}>
            <DashboardIcon color="primary" fontSize="small" />
            <Typography variant="caption" color="text.secondary">
              Admin Dashboard
            </Typography>
          </Box>
          <Typography variant="h5" fontWeight="bold">
            {selectedPage}
          </Typography>
        </Box>

        {renderContent()}
      </Box>
    </Box>
  );
};

export default AdminDashboard;